import React from 'react';
import {
  Button,
  Col,
  Row,
  Table,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Spinner,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import PosScheduleForm from '../components/PosScheduleForm';
import { BsPlusSquareFill } from 'react-icons/bs';
import { IconContext } from 'react-icons/lib';
import moment from 'moment-timezone';

class PosSyncStockTable extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isSyncing: false,
      logModal: false,
      logList: [],
      store_id: this.props.data.store_id,
      csvfile: '',
      selectedLog: '',
    };
  }

  componentDidMount() {
    this.getSyncLog();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChange = e => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  toggle = log => () => {
    return this.setState({
      logModal: !this.state.logModal,
      selectedLog: log ? log : '',
    });
  };

  getSyncLog() {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      limit: 100,
    };

    axios
      .post(url + ':3002/v1/product/store/inventory/sync/log', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            logList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  syncLog = e => {
    e.preventDefault();
    this.setState({ isSyncing: true });

    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      csvfile: this.state.csvfile,
      store_id: this.state.store_id,
      adjust_by: user.email,
    };

    axios
      .post(url + ':3002/v1/product/store/inventory/sync', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ isSyncing: false });
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Stock Log Synced successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });

        this.getSyncLog();
      })
      .catch(error => {
        if (error == 'Request Timeout') {
          this.setState({ isSyncing: false });
          this.getSyncLog();
        }
      });
  };

  render() {
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col>
            <Form onSubmit={this.syncLog}>
              <FormGroup row>
                <Col md={10}>
                  <Input
                    name="csvfile"
                    value={this.state.csvfile}
                    onChange={this.handleChange}
                    required
                  />
                </Col>
                <Col md={2}>
                  <Button type="submit" disabled={this.state.isSyncing}>
                    Sync
                  </Button>
                </Col>
              </FormGroup>
            </Form>
          </Col>
          {this.state.isSyncing && (
            <div
              style={{
                position: 'absolute',
                left: '40%',
              }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          )}
        </Row>

        <Table responsive hover className="ps-table th-no-wrap">
          <thead>
            <tr>
              {/* <th>Log</th> */}
              <th>Updated Date</th>
              <th>Updated By</th>
              <th>Log</th>
            </tr>
          </thead>
          <tbody>
            {this.state.logList.length < 1 && (
              <tr>
                <td colSpan="3">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the Create button to add new log</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.logList.length > 0 &&
              this.state.logList.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {moment(item.updated_dt)
                        .tz('Asia/Singapore')
                        .format('YYYY-MM-DD, HH:mm:ss')}
                    </td>

                    <td>{item.updated_by}</td>
                    <td>
                      <div className="ps-action-button">
                        <Button
                          className="theme-button theme-button-secondary"
                          onClick={this.toggle(item.log)}
                        >
                          View
                        </Button>
                      </div>
                      {/* {item.log.split('<br>').map((str, index) => {
                        return <p key={index}>{str}</p>;
                      })} */}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>

        <Modal
          isOpen={this.state.logModal}
          toggle={this.toggle(this.state.selectedLog)}
          className={this.props.className}
          centered
        >
          <ModalHeader>Log</ModalHeader>
          <ModalBody>
            {this.state.selectedLog.split('<br>').map((str, index) => {
              return <p key={index}>{str}</p>;
            })}
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggle(this.state.selectedLog)}
            >
              close
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default PosSyncStockTable;
